import { memo } from 'react';

export const AccountIcon = memo(function AccountIcon() {
  return (
    <div>
      <svg fill="none" height="29" viewBox="0 0 28 29" width="28" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.9164 27.3334C3.76124 27.3334 3.60766 27.3028 3.46431 27.2434C3.32097 27.184 3.19064 27.097 3.08093
          26.9873C2.97122 26.8776 2.8842 26.7473 2.82482 26.6039C2.76544 26.4606 2.73487 26.307 2.73487
          26.1518C2.73107 23.5354 3.76347 21.0239 5.6063 19.1666C6.51082 18.2386 7.5921 17.5011 8.78629
          16.9978C9.98047 16.4945 11.2634 16.2355 12.5593 16.2361H15.4404C16.7364 16.2354 18.0194 16.4944
          19.2136 16.9977C20.4079 17.501 21.4892 18.2385 22.3938 19.1666C24.2365 21.024 25.2687 23.5354 25.2651
          26.1518C25.2651 26.4652 25.1406 26.7657 24.9191 26.9873C24.6975 27.2089 24.397 27.3334 24.0837
          27.3334H3.9164ZM6.26371 19.8147C4.59187 21.4998 3.655 23.7781 3.65793 26.1518C3.65802 26.2205 3.68527
          26.2863 3.7338 26.3348C3.78232 26.3833 3.84812 26.4106 3.91675 26.4107H24.0844C24.153 26.4106 24.2188
          26.3833 24.2673 26.3348C24.3159 26.2863 24.3431 26.2205 24.3432 26.1518C24.3461 23.7781 23.4093 21.4998
          21.7375 19.8147C20.9186 18.974 19.9395 18.3058 18.858 17.8497C17.7766 17.3936 16.6148 17.1588 15.4411
          17.1592H12.56C11.3864 17.1588 10.2245 17.3936 9.14309 17.8497C8.06167 18.3058 7.08265 18.9739 6.26371
          19.8147ZM7.60633 8.06298C7.60591 6.79825 7.98054 5.5618 8.68288 4.51001C9.38521 3.45823 10.3836 2.63833
          11.5519 2.15405C12.7203 1.66976 14.006 1.54281 15.2465 1.78928C16.487 2.03576 17.6265 2.64457 18.5209
          3.53871C19.4153 4.43286 20.0246 5.57218 20.2715 6.81257C20.5184 8.05297 20.3919 9.33874 19.908
          10.5072C19.4241 11.6757 18.6046 12.6745 17.553 13.3772C16.5015 14.0799 15.2651 14.4549 14.0004
          14.4549C12.3056 14.4534 10.6805 13.7798 9.48181 12.5816C8.28308 11.3835 7.60861 9.75885 7.60633
          8.06403V8.06298ZM8.67755 8.06298C8.67705 9.11585 8.98883 10.1452 9.57341 11.0209C10.158 11.8965
          10.9891 12.5792 11.9617 12.9824C12.9343 13.3857 14.0046 13.4915 15.0373 13.2864C16.07 13.0813
          17.0187 12.5745 17.7633 11.8302C18.508 11.0859 19.0152 10.1374 19.2208 9.10482C19.4264 8.07222
          19.3212 7.0018 18.9184 6.02903C18.5156 5.05626 17.8333 4.22484 16.9579 3.63985C16.0825 3.05485
          15.0533 2.74258 14.0004 2.74258C12.5892 2.74381 11.2362 3.30486 10.2383 4.30259C9.24032 5.30032
          8.67906 6.65323 8.67755 8.06438V8.06298Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="0.5"
        />
      </svg>
    </div>
  );
});
